import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Index from './components/Index';
import Media from './components/Media';
import Cards from './components/Cards';
import Faq from './components/Faq';
import Comments from './components/Comments';
import About from './components/About';
import Updates from './components/Updates';
import Topics from './components/Topics';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Carousel from './components/Carousel';
import App from './components/App';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Index />
        <Media />
        <Cards />
        <Faq />
        <Comments />
        <About />
        <Updates />
        <Topics />
        <Ranking />
        <Contact />
        <Carousel />
        <App />
      </main>
      <Footer />
    </>
  );
}